import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  TagRightIcon,
  useToast,
  VStack
} from '@chakra-ui/react'
import LevelRewardsForm from './Form'
import { AdminLevelReward } from '@olagg/db-types'
import useLevelRewards from './hooks/useLevelRewards'
import { LevelRewardFormData } from '@olagg/validation-schemas'

const EditLevelReward = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getLevelReward, updateLevelReward, loading } = useLevelRewards()

  const [levelReward, setLevelReward] = useState<AdminLevelReward | null>(null)
  const [loadingLevelReward, setLoadingLevelReward] = useState(true)

  useEffect(() => {
    const loadLevelReward = async () => {
      if (!id) return
      try {
        setLoadingLevelReward(true)
        const levelRewardData = await getLevelReward(id)
        setLevelReward(levelRewardData.levelReward)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar el premio',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate('/claw-machine-prizes')
      } finally {
        setLoadingLevelReward(false)
      }
    }

    loadLevelReward()
  }, [id])

  const onSubmit = async (data: LevelRewardFormData) => {
    if (!levelReward) return

    try {
      await updateLevelReward(levelReward.id, data)
      toast({
        title: 'Premio actualizado',
        description: 'El premio ha sido actualizado exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate('/level-rewards')
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar el premio',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate('/level-rewards')
  }

  if (loadingLevelReward) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!levelReward) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Premio no encontrado
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar Premio por Nivel</Heading>

        <LevelRewardsForm
          initialData={levelReward}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default EditLevelReward;